import React from 'react'
import { Typography } from '@mui/material'
import { Link } from 'react-router-dom'

export default function DirectoryDetailLink({ to, children }) {
  return <Typography component={Link} to={to} fontWeight={500} sx={{ color: 'primary.main', textDecoration: 'none', '&:visited': { color: 'primary.main' }, '&:hover, &:focus-visible': { textDecoration: 'underline' } }}>{children}</Typography>
}
